import { connect } from 'react-redux';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import OrderUtils from 'utils/Order';
import RetailDeliveryFeeItemEN from 'components/SharedComponents/RetailDeliveryFeeItem/locales/RetailDeliveryFeeItem_en_US';
import RetailDeliveryFeeItemFR from 'components/SharedComponents/RetailDeliveryFeeItem/locales/RetailDeliveryFeeItem_fr_CA';

const { getRDF, isZeroPrice, SHIPPING_GROUPS } = OrderUtils;

// Minnesota's Retail Delivery Fee exempts gift-card/electronic (non-physical delivery)
// shipping groups (POST-252, ECSC-10129). This exemption is MN-specific - other states'
// RDF (e.g. Colorado's flat per-purchase fee, ECSC-10185) still applies to gift-card orders.
const RDF_EXEMPT_SHIPPING_GROUP_TYPES = [SHIPPING_GROUPS.GIFT, SHIPPING_GROUPS.ELECTRONIC, SHIPPING_GROUPS.SDU_ELECTRONIC];
const RDF_EXEMPT_STATE = 'MN';
const { wrapHOC } = FrameworkUtils;
const { getLocalisedDataFromResource, getTextFromResource } = LanguageLocaleUtils;

const getText = getLocalisedDataFromResource(RetailDeliveryFeeItemEN, RetailDeliveryFeeItemFR);

const mapStateToProps = (state, ownProps) => {
    const defaultText = getTextFromResource(getText, 'defaultText')(state);

    const feesAsArray = state.order?.orderDetails?.priceInfo?.fees;
    const priceInfo = ownProps.priceInfo;
    const isCheckout = ownProps.isCheckout;
    const isOrderConfirmation = ownProps.isOrderConfirmation;
    const orderDetails = state.order?.orderDetails;

    let feeAmount = getRDF({
        feesAsArray,
        priceInfo,
        orderDetails,
        isCheckout,
        isOrderConfirmation
    });

    if (!feeAmount) {
        const orderLevelRDF = orderDetails?.priceInfo?.retailDeliveryFee;

        if (orderLevelRDF && !isZeroPrice(orderLevelRDF)) {
            feeAmount = orderLevelRDF;
        }
    }

    let qty = feeAmount;

    if (isCheckout && !feeAmount) {
        qty = getTextFromResource(getText, 'qtyTbd')(state);
    }

    const hasShippingGroups = state.order?.orderDetails?.shippingGroups?.shippingGroupsEntries?.length;

    const shippingGroupAddress =
        ownProps.shippingGroupAddress || state.order?.orderDetails?.shippingGroups?.shippingGroupsEntries?.[0]?.shippingGroup?.address || {};
    const { postalCode: shippingPostalCode = '', state: shippingState = '' } = shippingGroupAddress;

    const isRdfExemptGroup = RDF_EXEMPT_SHIPPING_GROUP_TYPES.includes(ownProps.shippingGroupType) && shippingState === RDF_EXEMPT_STATE;
    let visible = false;

    if (hasShippingGroups && !isRdfExemptGroup) {
        visible = Boolean(shippingPostalCode !== '' && shippingState !== '' && feeAmount);
    }

    return {
        defaultText,
        qty,
        visible
    };
};

const withRetailDeliveryFeeItemProps = wrapHOC(connect(mapStateToProps));

export { withRetailDeliveryFeeItemProps };
